import dayjs from 'dayjs';
import { CaseHistoryResponseDto } from '@bandido/shared/dtos';
import { Channels } from '@bandido/shared/constants';

import { MessageFactory } from '../../messageFactory';
import { DateDivider } from '../DateDivider';
import CaseLog from '../CaseLogItem';

interface MessageGroup {
  author: string;
  channel: Channels;
  messages: CaseHistoryResponseDto[];
}

interface MessageRendererProps {
  group: MessageGroup;
  lastMessageDate: string | null;
  isCurrentUser: (history: CaseHistoryResponseDto) => boolean;
}

const shouldShowDateDivider = (currentDate: dayjs.Dayjs, lastMessageDate: string | null) => {
  if (!lastMessageDate) return true;
  return !dayjs(lastMessageDate).isSame(currentDate, 'day');
};

export const MessageRenderer = ({ group, lastMessageDate, isCurrentUser }: MessageRendererProps) => {
  const { author, channel, messages } = group;
  const [firstMessage] = messages;
  const currentDate = dayjs(firstMessage.createdAt).startOf('day');
  const showDateDivider = shouldShowDateDivider(currentDate, lastMessageDate);

  if (channel === Channels.CASE_LOG) {
    return (
      <>
        {showDateDivider && <DateDivider date={firstMessage.createdAt} />}
        <CaseLog authorFullName={author} key={firstMessage.id} messages={messages} isCurrentUser={isCurrentUser} />
      </>
    );
  }

  const MessageItem = MessageFactory[channel];
  return (
    <>
      {showDateDivider && <DateDivider date={firstMessage.createdAt} />}
      {messages.map((history) => (
        <MessageItem key={history.id} history={history} isCurrentUser={isCurrentUser(history)} />
      ))}
    </>
  );
};
